import {InView} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export interface LoadMoreComponentDisplayConfig {
  tilesBeforeFirstDisplay: number;
  tilesBeforeConsecutivelyDisplay: number;
}

interface PageControls {
  mountNextPage: VoidFunction;
  loadMoreComponentDisplayConfig?: LoadMoreComponentDisplayConfig;
  rootMargin?: `${number}px`;
}

export const ProductStreamTokenPagination: React.FC<PageControls> = ({
  mountNextPage,
  loadMoreComponentDisplayConfig,
  rootMargin = '1500px',
}) => {
  const handleLoadMore = (inView: boolean) => {
    if (inView) {
      mountNextPage();
    }
  };

  return (
    <InView
      onChange={handleLoadMore}
      data-testid="loadTriggerIntersectionObserver"
      rootMargin={rootMargin}
    >
      <LoadMoreTriggerBlock
        data-testid={`loadMoreTriggerBlock_${
          loadMoreComponentDisplayConfig?.tilesBeforeFirstDisplay ?? 0
        }`}
      />
    </InView>
  );
};

const LoadMoreTriggerBlock = styled.div`
  width: 100%;
  height: 50px;
`;
